import * as React from "react";
import { forwardRef } from "react";
const SvgLogoType = (props, ref) => /* @__PURE__ */ React.createElement("svg", { width: 160, height: 22, viewBox: "0 0 160 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, ...props }, /* @__PURE__ */ React.createElement("text", { x: 0, y: 17, fontFamily: "Inter, sans-serif", fontWeight: 600, fontSize: 20, fill: "currentColor", letterSpacing: 0.5 }, "VocaDoc Call"));
const ForwardRef = forwardRef(SvgLogoType);
export default ForwardRef;
